module.exports = __webpack_public_path__ + "img/userD04.c2895104.jpg";